import { gql } from '@generated/gql';

export const submitDepositDetails = gql(`
  mutation SubmitDepositMutation(
          $basketId: ID!
          $paymentDetails: PaymentDetails!
  ) {
        submitDeposit(basketId: $basketId, payment: $paymentDetails) {
          ... on CardPaymentAuthorised {
              transactionToken
          },
          ... on CardPayment3DSChallenge {
              transactionData
              externalTransactionToken
          },
          ... on CardPaymentDeclined {
              error
          }
    }
  }
`);

export const continueDeposit3DS = gql(`
  mutation Continue3DS($basketID: ID!, $token: String!) {
      continue3DS(basketId: $basketID, token: $token) {
          ... on CardPaymentAuthorised {
              transactionToken
          }
          ... on CardPaymentDeclined {
              error
          }
      }
  }
`);

export const completeDeposit3DS = gql(`
  mutation Complete3DS($basketID: ID!, $token: String!) {
    complete3DS(basketId: $basketID, token: $token) {
        ... on CardPaymentAuthorised {
            transactionToken
        }
        ... on CardPayment3DSChallenge {
            transactionData
        }
        ... on CardPaymentDeclined {
            error
        }
    }
  }
`);
